import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../../../contexts/ThemeContext';
import { useAuth } from '../../../../contexts/AuthContext';
import { SyncActivityLiveLogContent } from '../../../system-health/components/SyncActivityLiveLog';
import { systemHealthLinkPath } from '../../../system-health/utils';
import { viewAllLinkClass, widgetCardClass, widgetTitleClass } from '../../themeHelpers';
import { cn } from '../../../../lib/utils';

export interface LiveSyncLogWidgetProps {
  embedded?: boolean;
  settings?: Record<string, unknown>;
  isEditing?: boolean;
  maxLines?: number;
}

const LiveSyncLogWidget: React.FC<LiveSyncLogWidgetProps> = ({ embedded, settings, maxLines = 150 }) => {
  const effectiveMaxLines = (settings?.maxLines as number) ?? maxLines;
  const { colors } = useTheme();
  const { can } = useAuth();
  const healthLink = systemHealthLinkPath(can('system_health', 'edit'));
  const cardClass = widgetCardClass(colors, embedded);

  return (
    <div className={cn(cardClass, embedded && 'flex flex-col min-h-0')}>
      <div className="flex items-center justify-between mb-3 flex-shrink-0 gap-2">
        <h2 className={widgetTitleClass(colors)}>Live sync log</h2>
        <Link to={healthLink} className={viewAllLinkClass(colors)}>
          System Health
        </Link>
      </div>
      <SyncActivityLiveLogContent
        embedded
        maxLines={effectiveMaxLines}
        showFooterNote={false}
      />
    </div>
  );
};

export default LiveSyncLogWidget;
